// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--inbox-main-content{
    max-width: 1920px;
    width: 100%;
    padding: 10px 130px 100px 130px;
}

.scl--ibx-head-const-box{
    width: 100%;
}

.scl--ibx-filt-const-box{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 15px;
    padding-top: 15px;
}

.scl--ibx-filt-status{
    width: 108px;
}

.scl--ibx-filt-search{
    width: 279px;
}

.scl--ibx-filt-type{
    width: 108px;
}

.scl--ibx-action-const-sty{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.scl--ibx-action-const-sty span{
    padding: 0;
    margin: 0;
    color: rgba(138, 139, 143, 0.2);
    font-size: 12px;
}

.scl--ibx-action-const-sty button{
    width: 19px;
    height: 19px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.scl--ibx-eye-btn-const-sty svg path, .scl--ibx-eye-btn-const-sty svg circle{
    stroke: rgba(138, 139, 143, 1);
}

.scl--ibx-tras-btn-const-sty svg path{
    stroke: rgba(254, 86, 107, 1);
}

.scl--ibx-tras-btn-const-sty{
    border-radius: 4px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scl--ibx-eye-btn-const-sty{
    transition: all 0.3s;
    border-radius: 4px;
}

.scl--ibx-eye-btn-const-sty:hover{
    background-color: rgba(156, 156, 156, 0.24);
}

.scl--ibx-eye-btn-const-sty:hover svg, .scl--ibx-eye-btn-const-sty:hover svg circle{
    stroke: black;
}

.scl--ibx-tras-btn-const-sty:hover{
    background: rgba(255, 236, 239, 1);
}

.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main thead th{
    padding-left: 0px;
}

.scl--ibx-tabl-const-box{
    margin-top: 10px;
}
.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-select-cell-content{
    padding-left: 0px;
}


.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{
    text-transform: uppercase;
}

.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6){
    color: var(--typography-text-body-secondary);
}
.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td {
  max-width: 0; /* this is the key — forces fixed layout to actually clip */
    padding-left: 0px;
}

.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block; /* change from inline-flex to block */
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/inbox/css/inbox.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;AACA;EACE,YAAY,EAAE,2DAA2D;IACvE,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,qCAAqC;AACvD","sourcesContent":[".scl--inbox-main-content{\n    max-width: 1920px;\n    width: 100%;\n    padding: 10px 130px 100px 130px;\n}\n\n.scl--ibx-head-const-box{\n    width: 100%;\n}\n\n.scl--ibx-filt-const-box{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding-top: 15px;\n}\n\n.scl--ibx-filt-status{\n    width: 108px;\n}\n\n.scl--ibx-filt-search{\n    width: 279px;\n}\n\n.scl--ibx-filt-type{\n    width: 108px;\n}\n\n.scl--ibx-action-const-sty{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.scl--ibx-action-const-sty span{\n    padding: 0;\n    margin: 0;\n    color: rgba(138, 139, 143, 0.2);\n    font-size: 12px;\n}\n\n.scl--ibx-action-const-sty button{\n    width: 19px;\n    height: 19px;\n    border: none;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n}\n\n.scl--ibx-eye-btn-const-sty svg path, .scl--ibx-eye-btn-const-sty svg circle{\n    stroke: rgba(138, 139, 143, 1);\n}\n\n.scl--ibx-tras-btn-const-sty svg path{\n    stroke: rgba(254, 86, 107, 1);\n}\n\n.scl--ibx-tras-btn-const-sty{\n    border-radius: 4px;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scl--ibx-eye-btn-const-sty{\n    transition: all 0.3s;\n    border-radius: 4px;\n}\n\n.scl--ibx-eye-btn-const-sty:hover{\n    background-color: rgba(156, 156, 156, 0.24);\n}\n\n.scl--ibx-eye-btn-const-sty:hover svg, .scl--ibx-eye-btn-const-sty:hover svg circle{\n    stroke: black;\n}\n\n.scl--ibx-tras-btn-const-sty:hover{\n    background: rgba(255, 236, 239, 1);\n}\n\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main thead th{\n    padding-left: 0px;\n}\n\n.scl--ibx-tabl-const-box{\n    margin-top: 10px;\n}\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-select-cell-content{\n    padding-left: 0px;\n}\n\n\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{\n    text-transform: uppercase;\n}\n\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6){\n    color: var(--typography-text-body-secondary);\n}\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td {\n  max-width: 0; /* this is the key — forces fixed layout to actually clip */\n    padding-left: 0px;\n}\n\n.scl--ibx-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {\n  width: 100%;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block; /* change from inline-flex to block */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
